import React from 'react';
import './styles/ProductCardsE.css';

interface ProductCardProps {
  id: string;
  title: string;
  imageSrc: string;
  slug: string;
  quantity?: number;
}

const ProductCard: React.FC<ProductCardProps> = ({ id, title, imageSrc, quantity }) => {
  // Assume quantity prop is available, fallback to 1 if not
  const stockQuantity = typeof quantity === 'number' ? quantity : 1;
  return (
    <div className="product-card-e" key={id} style={{ position: 'relative' }}>
      {/* Out of Stock Badge */}
      {stockQuantity === 0 && (
        <div style={{position: 'absolute', top: 8, left: 8, background: '#ccc', color: '#fff', padding: '2px 8px', borderRadius: '8px', fontSize: '0.8rem', zIndex: 20}}>
          Out of Stock
        </div>
      )}
      <div className="product-card-image">
        <img src={imageSrc} alt={title} />
      </div>
      <div className="product-card-title">
        {title}
      </div>
    </div>
  );
};

export default ProductCard;